import classNames from "classnames";
import { Body14Regular } from "./typography/Body14Regular";

interface Props {
  isError: boolean;
  text: string;
  className?: string;
}

export const CustomHelperText: React.FC<Props> = ({
  isError,
  text,
  className,
}) => {
  const cn = classNames(
    isError
      ? "text-semantic-system-error-text mt-[8px]"
      : "text-semantic-text-tertiary",
    className
  );

  return (
    <div>
      <Body14Regular className={cn}>{text}</Body14Regular>
    </div>
  );
};
